import { render, staticRenderFns } from "./speechCraft.vue?vue&type=template&id=e1137cf4&scoped=true&"
import script from "./speechCraft.vue?vue&type=script&lang=js&"
export * from "./speechCraft.vue?vue&type=script&lang=js&"
import style0 from "./speechCraft.vue?vue&type=style&index=0&id=e1137cf4&prod&scoped=scoped&lang=css&"
import style1 from "./speechCraft.vue?vue&type=style&index=1&id=e1137cf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1137cf4",
  null
  
)

export default component.exports